<template>
  <transition name="modal" :data-score="scores()">
    <div class="results" v-if="category">
      <div class="row">
        <div class="col-sm-12 col-md-6">
          <div class="labels" v-if="category.blocks">
            <h2 class="h2" v-for="(block, i) in category.blocks" :key="i">
              <span class="label" v-html="block"></span>
            </h2>
          </div>
          <div class="labels" v-else>
            <h2 class="h2">
              <span class="label">{{ category.title }}</span>
            </h2>
          </div>
        </div>
        <div class="col-sm-12 col-md-6">
          <div v-html="category.intro"></div>
          <div class="social-items">
            <p>Del testen med andre</p>
            <ShareNetwork class="btn-link facebook-icon" network="facebook" url="https://ingenord.no/" :title="`${category.facebook}Er du? Ta testen her: https://ingenord.no`" :quote="`${category.facebook}Er du? Ta testen her: https://ingenord.no`"> Facebook </ShareNetwork>
            <a class="btn-link linkedin-icon" href="https://www.linkedin.com/shareArticle/?url=https://ingenord.no" target="_blank"> Linkedin </a>
          </div>
          <div class="btns">
            <p><a class="btn label arrow" href="https://www.cowi.no/ingenord" target="_blank">Møt noen av våre ingenørder</a></p>
            <p><a class="btn-link" href="https://ingenord.no/">Ta testen på nytt</a></p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import results from '../appdata/results.js'
import quiz from '../appdata/quiz.js'

import Modal from './common/ModalGeneric'

export default {
  data() {
    return {
      quiz: quiz,
      total: 0,
      categoryId: null,
      share: false
    }
  },

  computed: {
    ...mapGetters(['getAnswers']),
    category() {
      let categoryId = this.getCategoryId()
      return results[categoryId]
    }
  },
  methods: {
    getCategoryId() {
      if (this.scores() < 6) {
        return 3
      } else if (this.scores() < 10) {
        return 2
      } else if (this.scores() < 15) {
        return 1
      } else {
        return 0
      }
    },
    scores() {
      let answerPoints = 0

      if (Array.isArray(this.getAnswers)) {
        this.getAnswers.forEach(function(item) {
          answerPoints += item.value
        })
      }

      this.total = answerPoints

      return this.total
    }
  },
  mounted() {
    jQuery('body').addClass('bg-secondary')
    //console.log('ga fires')
    this.$ga.event('ingenord', 'quiz', 'fullført')
  }
}
</script>

<style lang="scss">
.social-items {
  position: relative;
  border: 1px solid #fff;
  padding: 0.75rem 1rem;
  display: inline-block;
  min-width: 305px;

  @media screen and (max-width: 991px) {
    min-width: 267px;

    max-width: 100%;
  }
  .btn-link {
    display: block;
    cursor: pointer;
  }
  p,
  .btn-link {
    font-size: 85%;
    font-weight: bold;
    margin: 0;
    padding: 0.25rem 0;
  }
}
.btns {
  p {
    margin-bottom: 0;
  }
  .btn.label,
  .btn-link {
    font-size: 85%;
  }
  @media screen and (max-width: 991px) {
    .btn.label.arrow {
      padding-left: 3.5rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Result.vue